import Reveal from "./Reveal";

const TILES = [
  { label: "Luxury Cafés", img: "/images/space-cafe.jpg", span: "md:col-span-7", ratio: "aspect-[16/10]" },
  { label: "Restaurants", img: "/images/space-restaurant.jpg", span: "md:col-span-5", ratio: "aspect-[4/3] md:aspect-auto md:h-full" },
  { label: "Hotels", img: "/images/space-hotel.jpg", span: "md:col-span-5", ratio: "aspect-[4/3] md:aspect-auto md:h-full" },
  { label: "Villas", img: "/images/space-villa.jpg", span: "md:col-span-7", ratio: "aspect-[16/10]" },
  { label: "Private Residences", img: "/images/space-residence.jpg", span: "md:col-span-6", ratio: "aspect-[16/9]" },
  { label: "Flats & Apartments", img: "/images/space-flat.jpg", span: "md:col-span-6", ratio: "aspect-[16/9]" },
  { label: "Lounges", img: "/images/space-lounge.jpg", span: "md:col-span-5", ratio: "aspect-[4/3] md:aspect-auto md:h-full" },
  { label: "Commercial Spaces", img: "/images/space-commercial.jpg", span: "md:col-span-7", ratio: "aspect-[16/10]" },
];

export default function Collections() {
  return (
    <section id="spaces" data-testid="spaces-section" className="bg-ivory py-28 md:py-40">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div>
              <p className="text-oxblood text-xs tracking-[0.45em] uppercase mb-6">Spaces We Furnish</p>
              <h2 className="font-display text-oxblood-ink text-4xl md:text-6xl leading-tight max-w-2xl">
                Where our furniture <em className="text-oxblood font-light">lives.</em>
              </h2>
            </div>
            <p className="text-ink/60 font-light max-w-sm text-sm leading-relaxed">
              From heritage Rajasthani interiors to contemporary luxury — furnished for spaces
              where premium people gather.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 md:mt-24 grid md:grid-cols-12 gap-6">
          {TILES.map((t, i) => (
            <Reveal key={t.label} delay={i * 0.05} className={t.span}>
              <div
                data-testid={`space-tile-${i}`}
                className={`group relative ${t.ratio} overflow-hidden border border-oxblood/20 hover:border-brass/60 transition-colors duration-500`}
              >
                <img
                  src={t.img}
                  alt={t.label}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-oxblood-ink/85 via-oxblood-ink/10 to-transparent" />
                <div className="absolute bottom-0 left-0 p-6 md:p-8">
                  <span className="font-display italic text-ivory text-2xl md:text-3xl">{t.label}</span>
                </div>
                <span className="absolute inset-4 border border-ivory/25 pointer-events-none group-hover:inset-3 transition-all duration-500" aria-hidden />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
